/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/FileUploader.css'

/**
 * Component for the FileUploader
 *
 * @export
 * @class FileUploader
 * @extends {React.Component<any, any>}
 */
export default class FileUploader extends React.Component<any, any> {

    /**
     * Creates an instance of FileUploader.
     *
     * @param {*} props
     * @memberof FileUploader
     */
    constructor(props: any) {
        super(props)

        this.state = {
            maxSize: props.maxSize,
            limitedSizeAction: props.limitedSizeAction,
            showAlert: true,
        }
    }

    /**
     * Will get the image file content in base64
     *
     * @param {*} e
     * @memberof FileUploader
     */
    _handleImageChange = (e: any) => {
        e.preventDefault()

        let reader = new FileReader()
        let file = e.target.files[0]

        if (this._checkMaxSize(file.size) && this._checkfile(file)) {
            reader.onloadend = () => {
                this.setState({
                    file: file,
                    imagePreviewUrl: reader.result,
                })

                this.props.getBase64(this.state.imagePreviewUrl)
            }

            reader.readAsDataURL(file)
        } else {
            this.state.limitedSizeAction(true)
        }
    }

    /**
     * Will check for the file size.
     * If <= maxSize defined, will return true
     * else will return false
     *
     * @param {number} size
     * @returns true or false
     * @memberof FileUploader
     */
    _checkMaxSize = (size: number) => { return (size <= this.state.maxSize) ? true : false }

    /**
     * Will check the format of the file for filtering
     * before sending it to the server
     *
     * @param {*} file
     * @returns true or false
     * @memberof FileUploader
     */
    _checkfile = (file: any) => {
        var validExts = new Array('image/jpg', 'image/jpeg', 'image/png')
        var fileType = file.type
        return (validExts.indexOf(fileType) < 0) ? false : true
    }

    render() {
        return (
            <div>
                <input
                    type="file"
                    onChange={this._handleImageChange}
                    className="password__upload"
                    accept="image/jpg, image/jpeg, image/png"
                />
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/FileUploader/FileUploader.tsx